module.exports = __webpack_public_path__ + "img/ctrl-canonical-stub-up--.0f970960.svg";